import { 
  getInsightRentention,
  getInsightRententionXh,
  getInsightRevenue, 
  getInsightRevenueXh, 
  getKeyMetricsPerformance, 
  getKeyMetricsPerformanceDownload, 
  getKeyMetricsPerformanceDownloadXh, 
  getKeyMetricsPerformanceXh, 
  getKeyMetricsTrendData,
  getKeyMetricsTrendDataXh,
  getKeyMetricsTrendRetentionData,
  getKeyMetricsTrendRetentionDataXh
} from "@/pages/dashboard/services/competitor"

export const COMPETITOR_REQ_TYPE = {
  "index": "normal",
  "xh-index": "xh",
}

type ReqType = keyof typeof COMPETITOR_REQ_TYPE; // Define a type for the keys

// Function to get the value for a key with a default fallback
export const getReqType = (key: string): string => {
  if (key in COMPETITOR_REQ_TYPE) {
    return COMPETITOR_REQ_TYPE[key as ReqType];
  } else {
    // Get the value of the first key in COMPETITOR_REQ_TYPE
    const firstKey = Object.keys(COMPETITOR_REQ_TYPE)[0] as ReqType;
    return COMPETITOR_REQ_TYPE[firstKey];
  }
};

export const competitorRequest: any = {
  getInsightRevenue: {
    normal: getInsightRevenue,
    xh: getInsightRevenueXh,
  },
  getInsightRentention: {
    normal: getInsightRentention,
    xh: getInsightRententionXh,
  },
  getKeyMetricsTrendData: {
    normal: getKeyMetricsTrendData,
    xh: getKeyMetricsTrendDataXh,
  },
  getKeyMetricsTrendRetentionData: {
    normal: getKeyMetricsTrendRetentionData,
    xh: getKeyMetricsTrendRetentionDataXh,
  },
  getKeyMetricsPerformance: {
    normal: getKeyMetricsPerformance,
    xh: getKeyMetricsPerformanceXh,
  },
  getKeyMetricsPerformanceDownload: {
    normal: getKeyMetricsPerformanceDownload,
    xh: getKeyMetricsPerformanceDownloadXh,
  },
};

export const executeCompetitorRequest = (
  requestObj: any, 
  requestType: string, 
  variant: string, 
  param: any
  ) => {
    
  if (requestObj[requestType] && requestObj[requestType][variant]) {
    return requestObj[requestType][variant](param);
  } else {
    // Fallback to "normal"
    if (requestObj[requestType] && requestObj[requestType].normal) {
      return requestObj[requestType].normal(param);
    } else {
      throw new Error(`Invalid request type or variant: ${requestType} - ${variant}`);
    }
  }
}